// @ts-nocheck
import React from 'react';
import Button from '@mui/material/Button';
import { setupInterceptorsTo } from "../../Componentes/API/AxiosBuilder";
import axios from 'axios';
import { RUTA_API_USUARIOS } from "../../Contantes/Constantes";
import { useBody } from "../../Body/state/BodyContext";
import { useUsuarios } from "../State/UsuarioContext";

export function TiempoRestante({ fecha, id }) {
    const [vencida, setVencida] = React.useState(false);
    const axiosInstance = setupInterceptorsTo(axios.create());
    const { getSolicitudes } = useUsuarios();
    const { setSuccess, setMessage } = useBody();

    const convertirFecha = (fecha) => {
        var today = new Date();
        var fechaEnDate = new Date(fecha)
        var diffMs = (fechaEnDate - today);
        var diffDays = Math.floor(diffMs / 86400000); // dias
        var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // horas
        var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutos
        return <>{diffDays > 0 ? <>{diffDays} días ,</> : null} {diffHrs > 0 ? <>{diffHrs} horas ,</> : null} {diffMins > 0 ? <>{diffMins} minutos </> : null}</>
    }

    const reenviar = async () => {
        await axiosInstance({
            method: 'PUT',
            url: RUTA_API_USUARIOS + `/solicitudes/registro/${id}/addtime`,
        }).then(response => {
            setSuccess("La solicitud de reenvio fue realizada con exito")
            getSolicitudes()
        })
            .catch(error => {
                setMessage("Hubo un error al querer reenviar la solicitud (Código de error: 00039)")
            })
    }

    React.useEffect(() => {
        const hoy = new Date()

        setVencida(new Date(fecha).getTime() > hoy.getTime())
    }, [fecha])

    return (
        <>
            {vencida ?
                <div>{convertirFecha(fecha)}</div> : <Button variant="contained" color="primary" onClick={reenviar}> Reenviar </Button>
            }
        </>
    )
}